export default __webpack_public_path__ + "static/media/blue-bg.7458236a.png";